export default {"src":"/_next/static/media/right-shevron.595413b2.svg","height":16,"width":16};